import type { Message } from '../types';

/** One character folded for searching: lower case, accents removed ("espaço" finds "espaco"). Never changes the length, so positions still line up with the original text. */
function foldChar(c: string): string {
  const folded = c.normalize('NFD').replace(/\p{M}/gu, '').toLowerCase();
  return folded.length === c.length ? folded : c.toLowerCase().length === c.length ? c.toLowerCase() : c;
}

export function fold(text: string): string {
  let out = '';
  for (const c of text) out += foldChar(c);
  return out;
}

/** Indexes of the messages containing `query`, oldest first. System notices are skipped. */
export function findMatches(messages: Message[], query: string): number[] {
  const q = fold(query.trim());
  if (!q) return [];
  const hits: number[] = [];
  messages.forEach((m, i) => {
    if (m.role !== 'system' && typeof m.content === 'string' && fold(m.content).includes(q)) hits.push(i);
  });
  return hits;
}

export interface TextPart { text: string; match: boolean }

/** `text` cut into plain and matching parts, for highlighting. */
export function highlightParts(text: string, query: string): TextPart[] {
  const q = fold(query.trim());
  if (!q) return [{ text, match: false }];
  const haystack = fold(text);
  const parts: TextPart[] = [];
  let from = 0;
  for (let at = haystack.indexOf(q); at !== -1; at = haystack.indexOf(q, from)) {
    if (at > from) parts.push({ text: text.slice(from, at), match: false });
    parts.push({ text: text.slice(at, at + q.length), match: true });
    from = at + q.length;
  }
  if (from < text.length) parts.push({ text: text.slice(from), match: false });
  return parts.length > 0 ? parts : [{ text, match: false }];
}
